import { render, staticRenderFns } from "./Cancelled.vue?vue&type=template&id=477535c8"
import script from "./Cancelled.vue?vue&type=script&lang=js"
export * from "./Cancelled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports